var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute top-0 bottom-0 w-full h-full"},[_c('ParticipantList',{attrs:{"active":_vm.active,"listHeight":85.4,"showTitle":true,"showHeader":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }